import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";
import {
  resetAuthentication,
  setAccessToken,
} from "../store/features/authentication/authenticationSlice";
import { useAppDispatch } from "../store/hooks";
import { resetUser } from "../store/features/user/userSlice";

interface AuthenticationMiddlewareProps {
  children?: any;
}


const AuthenticationMiddleware: React.FC<AuthenticationMiddlewareProps> = ({
  children,
}) => {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (isLoading) return;

    let active = true;
    if (isAuthenticated) {
      getAccessTokenSilently()
        .then((token) => {
          if (active) dispatch(setAccessToken(token));
        })
        .catch(() => {
          if (!active) return;
          dispatch(resetAuthentication());
          dispatch(resetUser());
          console.error("Failed to retrieve access token.");
        });
    } else {
      dispatch(resetAuthentication());
      dispatch(resetUser());
    }
    return () => {
      active = false;
    };
  }, [isAuthenticated, isLoading, getAccessTokenSilently, dispatch]);
  return <>{children}</>;
};

export default AuthenticationMiddleware;
